import { type ReactElement } from "react";
import { Alert, Stack, type AlertProps } from "@citibox-panel/ui";

const ALERT_SEVERITIES: NonNullable<AlertProps["severity"]>[] = [
  "error",
  "warning",
  "info",
  "success",
];

// All three anatomies, so the tinted strip, the notice and the solid fill can be judged side by
// side here rather than by opening a feature screen. `filled` is shown flat, outside a Snackbar:
// what is on trial is the surface contrast, not where the notice floats.
const ALERT_VARIANTS: NonNullable<AlertProps["variant"]>[] = ["standard", "notice", "filled"];

export function AlertDemo(): ReactElement {
  return (
    <Stack spacing={2}>
      {ALERT_VARIANTS.flatMap((variant) =>
        ALERT_SEVERITIES.map((severity) => (
          <Alert key={`${variant}-${severity}`} variant={variant} severity={severity}>
            {`${variant} ${severity} — mensaje de ejemplo`}
          </Alert>
        )),
      )}
    </Stack>
  );
}
